import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";

function Editprofile() {
  return (
    <div className="editProfile">
      <div className="editProfile-container">
        <div className="foto-profile">
          <img
            className="editProfile-img"
            src="http://via.placeholder.com/300"
            alt="foto profil"
          />

          <button type="submit">+</button>
        </div>

        <form className="editProfile-form">
          <p className="editProfile-title">Identitas Diri</p>
          <div className="editProfile-row">
            <label>Nama </label>
            <input type="text" className="form-control" />
          </div>

          <div className="editProfile-row">
            <label>Email</label>
            <input type="text" className="form-control" />
          </div>

          <div className="editProfile-row">
            <label>No. Telp</label>
            <input type="number" className="form-control" />
          </div>

          <div className="editProfile-row">
            <label>Password</label>
            <input type="password" className="form-control" />
          </div>

          <div className="editProfile-row">
            <label>Confirm Password</label>
            <input type="password" className="form-control" />
          </div>

          <div className="editProfile-row">
            <label>Alamat</label>
            <input type="text" className="form-control" />
          </div>

          <p className="editProfile-title">Identitas UMKM</p>
          <div className="editProfile-row">
            <label>Nama UMKM</label>
            <input type="text" className="form-control" />
          </div>

          <div className="editProfile-row">
            <label>Alamat</label>
            <input type="text" className="form-control" />
          </div>

          <div className="editProfile-row">
            <label>Tambah Anggota</label>
            <input type="text" className="form-control" />
          </div>
          <button className="editProfile-btn" type="submit">
            Simpan
          </button>
        </form>
      </div>

      <div className="daftarAnggota">
        <p className="editProfile-title">Daftar Anggota</p>
        <div className="daftarAnggota-card">
          <div className="daftarAnggota-card-info">
            <h2>Nama Anggota </h2>
            <h4>EmailAnggota@email.com</h4>
          </div>
          <div className="daftarAnggota-card-icons">
            <FontAwesomeIcon
              icon={faCircleXmark}
              className="daftarAnggota-card-delete"
            ></FontAwesomeIcon>
          </div>
        </div>

        <div className="daftarAnggota-card">
          <div className="daftarAnggota-card-info">
            <h2>Nama Anggota </h2>
            <h4>EmailAnggota@email.com</h4>
          </div>
          <div className="daftarAnggota-card-icons">
            <FontAwesomeIcon
              icon={faCircleXmark}
              className="daftarAnggota-card-delete"
            ></FontAwesomeIcon>
          </div>
        </div>

        <div className="daftarAnggota-card">
          <div className="daftarAnggota-card-info">
            <h2>Nama Anggota </h2>
            <h4>EmailAnggota@email.com</h4>
          </div>
          <div className="daftarAnggota-card-icons">
            <FontAwesomeIcon
              icon={faCircleXmark}
              className="daftarAnggota-card-delete"
            ></FontAwesomeIcon>
          </div>
        </div>

        <div className="daftarAnggota-card">
          <div className="daftarAnggota-card-info">
            <h2>Nama Anggota </h2>
            <h4>EmailAnggota@email.com</h4>
          </div>
          <div className="daftarAnggota-card-icons">
            <FontAwesomeIcon
              icon={faCircleXmark}
              className="daftarAnggota-card-delete"
            ></FontAwesomeIcon>
          </div>
        </div>
        <button className="editProfile-btn" type="submit">
          Tambah Anggota
        </button>
      </div>
    </div>
  );
}

export default Editprofile;
